// Liste des professions de santé pour les formulaires MSSanté
// Utilisée dans /mssante/inscription et le wizard de création BAL
export const PROFESSIONS = [
  "Médecin", "Masseur-kinésithérapeute", "Pharmacien", "Chirurgien-dentiste",
  "Sage-femme", "Pédicure-podologue", "Infirmier",
  "Médecin en formation", "Chirurgien-dentiste en formation",
  "Sage-femme en formation", "Pharmacien en formation",
  "Assistant de service social", "Assistant dentaire",
  "Opticien-lunetier", "Audioprothésiste",
  "Technicien de laboratoire médical", "Manipulateur d'ERM",
  "Physicien médical", "Psychomotricien", "Diététicien",
  "Ergothérapeute", "Orthophoniste", "Orthoptiste",
  "Psychologue", "Psychothérapeute", "Ostéopathe", "Chiropracteur",
  "Orthopédiste-orthésiste", "Orthoprothésiste", "Podo-orthésiste",
  "Épithésiste", "Oculariste", "Militaires",
  "Accompagnant éducatif et social", "Aide à domicile",
  "Aide médico-psychologique", "Aide-soignant", "Assistant médical",
  "Auxiliaire de puériculture", "Auxiliaire de vie sociale",
  "Coordonnateur de parcours", "Directeur d'établissement",
  "Éducateur", "Gestionnaire santé", "Préparateur en pharmacie",
  "Secrétaire médico-administrative", "Autre professionnel",
];
